import Vue from 'vue';

import Vuex from 'vuex';

import common from './modules/common.module';

//Auth Modules
import auth from './modules/auth.module'; 


import admin from './modules/admin.module';

import depositModule from './modules/deposit.module';

import categoryModule from './modules/category.module';

import mutualModule from './modules/mutual.module';

import bullionsModule from './modules/bullions.module';

import equitiesModule from './modules/equities.module';

import registerAuthModule from './modules/register.auth.module';
 
import profileModule from './modules/profile.module';

import homeloanModule from './modules/homeloan.module';
import commodityModule from './modules/commodity.module';
import retirementModule from './modules/retirement.module';
import insuranceModule from './modules/insurance.module';
import realEstateModule from './modules/realEstate.module';
import privateInvestmentModule from './modules/privateInvestment.module';
import accountModule from './modules/account.module';
import investometerModule from './modules/investometer.module';
import createPersistedState from 'vuex-persistedstate';
import createMutationsSharer from 'vuex-shared-mutations';
import keepSafeCategory from './modules/KeepsafeCategory.module';
import DepositKeepSafe from './modules/DepositKeepSafe.module'; 
import keep_safe_form from './modules/keep_safe_form.module';
import MutualFundKeepSafe from './modules/MutualFundKeepSafe.module'; 
import RealEstateKeepSafe from './modules/RealEstateKeepSafe.module'; 
import EquityBondKeepSafe from './modules/EquityBondKeepSafe.module';
import CommodityKeepSafe  from './modules/CommodityKeepSafe.module'; 
import InsuranceKeepSafe  from './modules/InsuranceKeepSafe.module';
import RetirementKeepSafe  from './modules/RetirementKeepSafe.module';
import BullionsKeepSafe  from './modules/BullionsKeepSafe.module';
import PrivateInvestmentKeepSafe  from './modules/PrivateInvestmentKeepSafe.module'; 
import TaxFillingKeepSafe  from './modules/TaxFillingKeepSafe.module'; 
import payment  from './modules/payment.module';    


Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
    	common,
    	auth,
    	admin,
    	depositModule,
    	categoryModule,
        mutualModule,
        bullionsModule,
        equitiesModule,
        registerAuthModule,
        profileModule,
        homeloanModule,
        commodityModule,
        retirementModule,
        realEstateModule,
        privateInvestmentModule,
        keepSafeCategory,
        DepositKeepSafe,
        investometerModule,
        insuranceModule,
        accountModule,
        keep_safe_form,
        MutualFundKeepSafe,
        RealEstateKeepSafe,
        EquityBondKeepSafe,
        CommodityKeepSafe,
        InsuranceKeepSafe,
        RetirementKeepSafe,
        BullionsKeepSafe,
        PrivateInvestmentKeepSafe,
        TaxFillingKeepSafe,
        payment
    },
    plugins: [
        createMutationsSharer({ predicate: ['logout', 'setUser'] })
    ]
});